/*
 * dd-install-date.js
 * ------------------
 * Fills any element marked with [data-dd-install-date] with a client-computed
 * "today + 9 weeks" date string, e.g. "July 25, 2026".
 *
 * Why client-side: the storefront PDP and cart drawer can be served from the
 * Shopify CDN cache; the Liquid `'now' | date` fallback in
 * snippets/dd-install-date.liquid is whatever timestamp existed when the
 * cached HTML was rendered (potentially hours stale). This script overrides
 * the fallback as soon as the page hydrates so customers see an accurate
 * recommended-after date regardless of cache age.
 *
 * Re-fires on:
 *   - DOMContentLoaded (initial paint).
 *   - DOM mutations that introduce new [data-dd-install-date] nodes — covers
 *     the cart drawer opening, Section Rendering API swaps after a swatch
 *     selection, etc.
 *   - The custom event `dd:install-date:refresh` dispatched on `document` —
 *     escape hatch for any caller that knows it just inserted a node and
 *     wants a synchronous fill instead of waiting for the observer microtask.
 *
 * Idempotent: filled nodes carry [data-dd-install-date-filled] and are
 * skipped on subsequent passes. The IIFE itself short-circuits if the
 * script is included twice (PDP + cart drawer both register it).
 */
(function () {
  if (window.__ddInstallDateInit) return;
  window.__ddInstallDateInit = true;

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var ATTR = 'data-dd-install-date';
  var FILLED = 'data-dd-install-date-filled';
  var WEEKS_OUT = 9;

  function format(d) {
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function fill(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[' + ATTR + ']:not([' + FILLED + '])');
    if (!nodes.length) return;
    var d = new Date();
    d.setDate(d.getDate() + WEEKS_OUT * 7);
    var formatted = format(d);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = formatted;
      nodes[i].setAttribute(FILLED, '');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fill(); });
  } else {
    fill();
  }

  document.addEventListener('dd:install-date:refresh', function (e) {
    fill(e && e.target && e.target.querySelectorAll ? e.target : document);
  });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          var hasAttr = n.matches && n.matches('[' + ATTR + ']:not([' + FILLED + '])');
          var hasChild = n.querySelector && n.querySelector('[' + ATTR + ']:not([' + FILLED + '])');
          if (hasAttr || hasChild) {
            fill(n.parentNode || document);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.ddRefreshInstallDates = fill;
})();
